import React from "react";
import { useViewChannelBalances } from "../../../hooks/useViewChannelBalances";
import MpesaBalanceCard from "./cards/MpesaBalanceCard";
import BankBalanceCard from "./cards/BankBalanceCard";
import AirtelBalanceCard from "./cards/AirtelBalanceCard";

export default function ChannelBalancesSection() {
  const viewChannelBalances = useViewChannelBalances();

  if (!viewChannelBalances) {
    return null;
  }

  return (
    <div className="mb-6 sm:mb-12">
      <h2 className="text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4">
        Channel Balances
      </h2>
      <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        <MpesaBalanceCard />
        <BankBalanceCard />
        <AirtelBalanceCard />
      </div>
    </div>
  );
}
